export const SET_TOKEN = 'SET_TOKEN'
export const REMOVE_TOKEN = 'REMOVE_TOKEN'

export const GET_PROFILE = 'GET_PROFIKE'

export const GET_TRANSLATIONS = 'GET_TRANSLATIONS'
